import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Experience.css';

const Experience = () => {
  const { tr } = useLanguage();

  return (
    <section id="experiencia" className="experience">
      <p className="section-title">{tr.experience.title}</p>
      <div className="exp-list">
        {tr.experience.jobs.map((job, i) => (
          <div key={i} className="exp-item">
            <div className="exp-meta">
              <span className="exp-role">{job.role}</span>
              <span className="exp-company">{job.company}</span>
              <span className="exp-period">{job.period}</span>
            </div>
            <ul className="exp-highlights">
              {job.highlights.map((h, j) => (
                <li key={j}>{h}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
